import { render, staticRenderFns } from "./TheSettingsList.vue?vue&type=template&id=1e62b454&scoped=true"
import script from "./TheSettingsList.vue?vue&type=script&lang=ts"
export * from "./TheSettingsList.vue?vue&type=script&lang=ts"
import style0 from "./TheSettingsList.vue?vue&type=style&index=0&id=1e62b454&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e62b454",
  null
  
)

export default component.exports